import { WelcomeGiftDto } from '@coretava/api/ecommerce-service';
import { formatWelcomeGiftValue } from '@gamiphy/loyalty-station-desktop/components/cashback/utils';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { Trans } from '@gamiphy/react-i18n';
import Close from '@mui/icons-material/Close';
import {
  Box, Button, Grid, Typography,
} from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import animationData from './assets/gift.json';

const ReactLottie = React.lazy(() => import('lottie-react'));

const WelcomeGiftNotification: React.FC<{ welcomeGift: WelcomeGiftDto }> = observer(({ welcomeGift }) => {
  const handleClaimWelcomeGiftNotification = React.useCallback(() => {
    UiStore.open();
    UiStore.setSignupFlowStarted(true);
    UiStore.openSignupPopup();
  }, []);

  return (
    <Box bgcolor="#fff">
      <Box p={1} bgcolor="#0000000D">
        <Grid container justifyContent="space-between">
          <ReactLottie
            animationData={animationData}
            loop
            autoplay
            style={{
              maxWidth: '100%',
              width: '60px',
              height: 'auto',
              maxHeight: '60px',
            }}
          />
          <Grid
            container
            width={27}
            height={27}
            bgcolor="#E2DEE9"
            borderRadius="50%"
            justifyContent="center"
            alignItems="center"
            onClick={() => UiStore.closeWelcomeGiftNotification()}
            sx={{
              '&:hover': {
                cursor: 'pointer',
              },
            }}
          >
            <Close />
          </Grid>
        </Grid>
        <Typography fontSize={24} fontWeight={600} mt={1}>
          <Trans
            i18nKey="welcomeGift.notification.title"
            defaults="Receive your welcome gift!"
          />
        </Typography>
        <Typography>
          <Trans
            i18nKey="welcomeGift.notification.body"
            defaults="A {{welcomeGiftValue}} discount is waiting for you!"
            values={{
              welcomeGiftValue: formatWelcomeGiftValue(welcomeGift),
            }}
          />
        </Typography>
        <Box mt={1}>
          <Button
            variant="contained"
            sx={{ fontSize: 14 }}
            fullWidth
            onClick={() => handleClaimWelcomeGiftNotification()}
          >
            <Trans
              i18nKey="welcomeGift.notification.claimNow"
              defaults="Claim Your Gift"
            />
          </Button>
        </Box>
      </Box>
    </Box>
  );
});

export default WelcomeGiftNotification;
